import { productIndexValidate } from "../../application/dtos/product_index_validate";

export class productIndexEntity {
    constructor({id, sku, description, unit, stock, client}){
        this.id = id;
        this.sku =  sku;
        this.description = description;
        this.unit = unit;
        this.stock = stock;
        this.client = client;
    }

    isValid() {
        return productIndexValidate(this);
    }
}